import React from "react";
import { Navigate } from "react-router-dom";
import { useSelector } from "react-redux";
import Cookies from "js-cookie";
const PrivateRoute = ({ children }) => {
  const token =
    useSelector((state) => state.auth.token) || Cookies.get("token");

  if (!token) {
    return <Navigate to="/" />;
  }

  return children;
};

export default PrivateRoute;
